export const supportList = "support/admin_list";
export const supportAnswer = "support/new_answer";
export const supportChat = "support/chat";
